export enum InvoiceStatus {
  OUTSTANDING = 'OUTSTANDING',

  PAID = 'PAID',

  PARTIALLY_PAID = 'PARTIALLY_PAID',
}
